import { IsNotEmpty, MaxLength, IsDefined, IsPositive, IsNumber, IsNumberString } from 'class-validator';
import { computed } from 'mobx';

import { EntityModel } from 'src/core/services/data/models';
import { DataService, property } from 'src/core/services/data.service';
import { BookemZulu as Model } from 'src/core/services/data/JayDataContext';

export class EntityMappingDataService extends DataService<typeof Model.Products.Logic.ViewModels.EntityMappingItem, Model.Products.Logic.ViewModels.EntityMappingItem, EntityMappingItem> {
	protected map(entity: Model.Products.Logic.ViewModels.EntityMappingItem): EntityMappingItem {
		return new EntityMappingModel(entity);
	}

	public static make(ctx?: any): EntityMappingDataService {
		return new EntityMappingDataService(ctx, ctx => ctx.EntityMappings);
	}

}

export class EntityMappingModel extends EntityModel<Model.Products.Logic.ViewModels.EntityMappingItem, EntityMappingItem> implements EntityMappingItem {
	@property<EntityMappingModel>(o => o.entity.id, (o, value) => o.entity.id = value)
	public id: number;

	@property<EntityMappingModel>(o => o.entity.type, (o, value) => o.entity.type = value)
	public type: number;

	@computed
	public get typeText(): string {
		switch (this.entity.type) {
			case Model.Bookings.Domain.Models.EntityMappingType.Place:
				return 'Place';
			case Model.Bookings.Domain.Models.EntityMappingType.Region:
				return 'Region';
			case Model.Bookings.Domain.Models.EntityMappingType.Product:
				return 'Product';
		}
		return null;
	}

	@property<EntityMappingModel>(o => o.entity.displayName, (o, value) => o.entity.displayName = value)
	public displayName: string;

	@property<EntityMappingModel>(o => o.entity.productProviderName, (o, value) => o.entity.productProviderName = value)
	public productProviderName: string;

	@property<EntityMappingModel>(o => o.entity.bookemKey, (o, value) => o.entity.bookemKey = value)
	public bookemKey?: string;

	@property<EntityMappingModel>(o => o.entity.productProviderId, (o, value) => o.entity.productProviderId = value)
	public productProviderId: number;

	@property<EntityMappingModel>(o => o.entity.productProviderKey, (o, value) => o.entity.productProviderKey = value)
	public productProviderKey: string;

	@property<EntityMappingModel>(o => o.entity.isCheckedByUser, (o, value) => o.entity.isCheckedByUser = value)
	public isCheckedByUser: boolean;
}



// WEBPACK FOOTER //
// ./src/app/products/entity-mappings/entity-mapping.data.ts